import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api, { getToken, setToken as saveToken, clearToken } from "@/lib/apiClient";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [admin, setAdmin] = useState(null);
  // null = checking, false = not authed, object = authed
  const [state, setState] = useState(getToken() ? "checking" : "guest");

  const bootstrap = useCallback(async () => {
    if (!getToken()) {
      setState("guest");
      return;
    }
    try {
      const { data } = await api.get("/admin/me");
      setAdmin(data);
      setState("authed");
    } catch {
      clearToken();
      setAdmin(null);
      setState("guest");
    }
  }, []);

  useEffect(() => {
    bootstrap();
  }, [bootstrap]);

  const login = useCallback(async (username, password) => {
    const { data } = await api.post("/admin/login", { username, password });
    saveToken(data.access_token);
    setAdmin(data.admin);
    setState("authed");
    return data.admin;
  }, []);

  const logout = useCallback(async () => {
    try {
      await api.post("/admin/logout");
    } catch {
      /* ignore */
    }
    clearToken();
    setAdmin(null);
    setState("guest");
  }, []);

  return (
    <AuthContext.Provider value={{ admin, state, login, logout, refresh: bootstrap }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
